import React from 'react';
import {connect} from 'react-redux';
import RightMenuDetailsEksport from './RightMenuDetailsEksport';
import RightMenuDetailsHelp from './RightMenuDetailsHelp';

class RightMenuDetails extends React.Component {
    constructor(props) {
        super(props);

        this.setHeight = () => {
            let rightMenuDetails = document.getElementsByClassName('right-menu-details')[0];
            if (this.props && this.props.activeTable === 'SQUARES') {
                let topPosition = document.getElementsByClassName('single-grid-th')[0].clientHeight;
                let rightMenuHeight = document.getElementsByClassName('gridContainer')[0].offsetHeight;
                rightMenuDetails.style.height = (rightMenuHeight - topPosition) + 'px';
                rightMenuDetails.style.top = topPosition + 'px';
            }
            else {
                let topPosition = document.getElementById('rightMenuButtonsContainer').style.top;
                let rightMenuHeight = document.getElementsByClassName('colors-table')[0].offsetHeight + 'px';
                rightMenuDetails.style.height = rightMenuHeight;
                rightMenuDetails.style.top = topPosition;
            }
        }

    }

    componentDidMount() {
        this.setHeight();
        window.addEventListener('resize', this.setHeight)
    }

    componentDidUpdate() {
        this.setHeight()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setHeight)
    }

    render() {
        return (
            <div className="right-menu-details">
                <RightMenuDetailsEksport style={{display: this.props.id ==='eksport'?'':"none"}}/>
                <RightMenuDetailsHelp style={{display: this.props.id ==='pomoc'?'':"none"}}/>
            </div>
        )
    }
}

export default connect(
    state => ({
        id: state.rightMenuExpanded.id,
        activeTable: state.activeTable,
    })
)(RightMenuDetails)



// WEBPACK FOOTER //
// ./src/RightMenuDetails.js